import { render } from "./BerichtProduktionsspiegelMdm.pug?vue&type=template&id=21c3a07c&lang=pug"
import script from "./BerichtProduktionsspiegelMdm.js?vue&type=script&lang=js"
export * from "./BerichtProduktionsspiegelMdm.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__